import React from "react";

const SolverPreviewCardFooter = () => {
  return <div className="flex"></div>;
};

export default SolverPreviewCardFooter;
